import { logger } from './logger';

/**
 * Captures the base URL of the currently executing script during module initialization.
 * This must be captured at the top level because document.currentScript is only
 * available during the initial synchronous script execution.
 *
 * Used to load folders relative to the root script, keeping the same origin and version.
 */

const moduleScriptUrl = (document.currentScript as HTMLScriptElement | null)?.src || '';

const moduleBaseUrl = moduleScriptUrl ? new URL('.', moduleScriptUrl).href : '';

if (!moduleBaseUrl) {
  logger.warn(
    'Failed to capture script base URL during initialization. ' +
      'document.currentScript is not available. ' +
      'This may occur if the script was loaded dynamically or as an ES module.'
  );
}

export function getModuleBaseUrlOrThrow(): string {
  if (!moduleBaseUrl) {
    throw new Error(
      'Script base URL is not available. ' + 'Unable to load component resources because the script location could not be determined.'
    );
  }
  return moduleBaseUrl;
}
